var React = require('react');

function E2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"E2"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"48.77 54.05 51.56 33.45 25.3 29.89 15.61 49.56 48.77 54.05","fill":"#73c9bd","key":0}),React.createElement("polygon",{"points":"23.73 21.62 49.71 20.78 49.04 0 23.06 0.84 0 1.58 1.91 60.79 2.58 81.57 25.64 80.83 51.62 79.99 50.95 59.21 33.36 59.78 24.97 60.05 23.73 21.62","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

E2.defaultProps = {"viewBox":"0 0 51.62 81.57"};

module.exports = E2;

E2.default = E2;
